/*
*   路口管理组件
*   zxw
*   2024-05-20
*/

import React , { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import $ from 'jquery';
import CNF from '../../incs/Config';
import { Row, Col, message, Table, Input, 
    Select, Modal, Button, Dropdown, Upload,
    Tag, Badge, Popover,} from 'antd';
import { DownOutlined, PlusOutlined, 
    ExportOutlined, ImportOutlined,
    ExclamationCircleFilled } from '@ant-design/icons';
import { UjoinParams, AddRequestHeaders, 
    UdateFormat, winWidth, Html2pdf, MonthAgo} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './IntersectionEntity.js';
import MainImagePreview from './MainImagePreview';
import ProductInfo from '../commons/ProductInfo.js';

import XZTLOGO from '../../images/logo_head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';


const Option = Select.Option;
const { TextArea } = Input;
const MODULENAME = '路口';

let root = null;
let rootImage = null;

/**
 * 获取时长标签
 * 0：黄闪；-1：常绿；-2：关闭。
 * @param {*} time 
 * @returns 
 */
const duration = (time) => {
    if(parseInt(time) === 0){
        return <Tag color='gold'>黄闪</Tag>
    }else if(parseInt(time) === -1){
        return <Tag color='green'>常绿</Tag>
    }else if(parseInt(time) === -2){
        return <Tag color='red'>关闭</Tag>
    }else{
        return <span>{time}&nbsp;秒</span>
    }
};

/**
 * 获取配时长度
 * @param {*} timePeriodData 
 * @param {*} weeks 
 * @returns 
 */
const getTimePeriodLength = (timePeriodData,weeks) => {
    let length = 1;
    for(let i = 0; i < timePeriodData.length; i++){
        if(timePeriodData[i].week.length === weeks){
            length += 1;
        }
    }
    return length;
};

/**
 * 信息提示框组件
 * @param {*} props 
 * @returns 
 */
const InfoPromptModal = (props) => {
    const [open, setOpen] = useState(false);
    const [description, setDescription] = useState('');

    useEffect(()=>{
        setOpen(props.open);
    }, [props]);

    /**
     * 取消
     */
    const handleCancel = () =>{
        setDescription('');
        setOpen(false);
    }

    /**
     *  处理
     *  @param {*} record 
     *  @param {*} action 
     */
   const handleOK = () =>{
        $.ajax({
            url: `${CNF.api}intersections/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: props.action==='DELETE'?'DELETE':'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': props.action,
                'description': description
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1);
                }
                handleCancel();
            }
        })
    }

    return (
        <>
            <Modal
                okType='danger'
                title={<><ExclamationCircleFilled style={{ color: '#FAAD13' }} /> {MODULENAME}</>}
                closeIcon={false}
                open={open}
                onOk={()=>{handleOK()}}
                onCancel={()=>{handleCancel()}}
                okText='确认'
                cancelText='取消'
                okButtonProps={{disabled: description?false:true}}
            >
                <div>
                    <p style={{ marginTop: 0 }}>考虑清楚了？确定要{props.action==='DISABLE'?'禁用':props.action==='ACTIVE'?'激活':'删除'}该{MODULENAME}：{props.record.name}</p>
                    <TextArea
                        placeholder='必填字段，需要备注说明'
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        onChange={(e)=>{setDescription(e.target.value)}}
                        value={description}
                    />
                </div>
            </Modal>
        </>
    );
}

/**
 * 显示路口信息
 * @param {*} props 
 * @returns 
 */
const Info = (props) => {
    const [propsState, setPropsState] = useState(props);
    const [open, setOpen] = useState(false);
    const [timePeriodData, setTimePeriodData] = useState([]);
    const [timePeriodLogData, setTimePeriodLogData] = useState([]);
    const [directions, setDirections] = useState([]);
    const [imageData, setImageData] = useState([]);
    const [rold, setrRold] = useState('');
    const [roldInfo, setrRoldInfo] = useState([]);
    const handleCancel = () => { setOpen(false);};
    const printer = () => { 
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    const download = () => { Html2pdf('print-info-id', props.record.name,'');};

    /**
     * 判断最新是否有修改
     * @param {*} timeUlid 
     * @returns 
     */
    const timeUlidIsInTimePeriodLogData = (timeUlid) => {
        for(let i = 0; i < timePeriodLogData.length; i++){
            if(timePeriodLogData[i].timing_ulid === timeUlid){
                return true;
            }
        }
        return false;
    }

    /**
     * 返回最新的修改
     * @param {*} timeUlid 
     * @returns 
     */
    const returnTimePeriodLog = (timeUlid) => {
        let item = '';
        for(let i=0; i<timePeriodLogData.length; i++){
            if(timePeriodLogData[i].timing_ulid === timeUlid){
                item = timePeriodLogData[i];
                break;
            }
        }
        if(item){
            return <div>
                <div>时段：{item.time_period}</div>
                <div>方向：{item.direction}</div>
                <div>时长：{item.duration}s</div>
                <div>动作：{item.action}</div>
                <div>时间：{item.create_time}</div>
                <div>操作：{item.operation}</div>
            </div>;
        }else{
            return '';
        }
    }

    /**
     * 获取路线上的红绿灯信息
     * @param {*} roldName 
     * @returns 
     */
    const getRoadInfo = (roldName) => {
        if (roldName && roldName !==rold ){
            const params = {
                'road': roldName,
                'page_size': 65535,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.api}intersections${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',success:function(data){
                    if(data.res === 0){
                        //  更新road
                        setrRold(roldName);
                        //  更新roadInfo
                        if(data.dat.length > 0){
                            setrRoldInfo(data.dat);
                        }else{
                            setrRoldInfo([]);
                        }
                    }
                }
            })
        }
    }

    /**
     * 显示预览图片
     * @param {*} record 
     */
    const showPreviewImage = (record) =>{
        if(!rootImage){
            rootImage = ReactDOM.createRoot(document.getElementById('show-image-id'));
        }
        rootImage.render(
        <MainImagePreview
            open={true}
            record={record}
        />);
    }

    useEffect(()=>{
        setOpen(props.open);
    }, [props]);

    useEffect(() => {
        /**
         * 获取配置列表
         * @param {*} intersectionUlid 
         */
        const getIntersectionTiming = (intersectionUlid) => {
            const params = {
                'intersection_ulid': intersectionUlid,
                'page_size': CNF.pageSize * 100,
            };
            $.ajax({
                url: `${CNF.api}intersection/timings${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',success:function(data){
                    if(data.res === 0){
                        if(data.dat.length > 0){
                            // setIntersectionData(data.dat);
                            //  汇总路口方向
                            let d = [];
                            //  整合配时表格
                            let t = [];
                            let initTimePeriod = '';
                            let initWeek = [];
                            let durations = [];
                            for(let i=0; i<data.dat.length; i++){
                                let timeUlid = data.dat[i].key;
                                let timePeriod = data.dat[i].time_period;
                                let week = data.dat[i].week;
                                //  判断方向是否存在
                                if(!d.includes(data.dat[i].direction)){
                                    d.push(data.dat[i].direction);
                                }
                                //  基于星期和时段判断
                                if(initTimePeriod !== timePeriod || initWeek.toString() !== week.toString()){
                                    //  判断durations是否有值，
                                    //  若有，则之前已完成了一次基于星期和时段整合配时
                                    //  若无，则是初始化
                                    if(durations.length > 0){
                                        t.push({
                                            timePeriod: initTimePeriod,
                                            week: initWeek,
                                            durations: durations
                                        });
                                        durations = []; //  清空
                                    }
                                    initTimePeriod = timePeriod;
                                    initWeek = week;
                                }
                                //  将配时添加到数组中
                                durations.push({
                                    timeUlid: timeUlid,
                                    value: data.dat[i].duration
                                }); 
                                //  添加最后一个配时
                                if(i+1 === data.dat.length){
                                    t.push({
                                        timePeriod: initTimePeriod,
                                        week: initWeek,
                                        durations: durations
                                    });
                                }
                            }
                            setDirections(d);
                            setTimePeriodData(t);
                        }else{
                            setDirections([]);
                            setTimePeriodData([]);
                        }
                    }else{
                        message.error(data.msg, 1.5);
                    }
                }
            })
        }

        /**
         * 获取配时日志
         * @param {*} intersectionUlid 
         */
        const getIntersectionTimingLog = (intersectionUlid) => {
            const params = {
                'intersection_ulid': intersectionUlid,
                'create_time': MonthAgo(),
                'page_size': CNF.pageSize * 100,
            };
            $.ajax({
                url: `${CNF.api}log/timings${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',success:function(data){
                    if(data.res === 0){
                        if(data.dat.length > 0){
                            let d = [];
                            //  每个配时日志只取最新一条
                            for(let i=0; i<data.dat.length; i++){
                                let item = data.dat[i];
                                let isIn = false
                                for(let j=0; j<d.length; j++){
                                    if(d[j].timing_ulid === item.timing_ulid){
                                        isIn = true;
                                        break;
                                    }
                                }
                                if(!isIn){
                                    d.push(item);
                                }  
                            }
                            setTimePeriodLogData(d);
                        }else{
                            setTimePeriodLogData([]);
                        }
                    }else{
                        message.error(data.msg, 1.5);
                    }
                }
            })
        }
        //  初次加载调用，或者切换路口调用
        if(timePeriodData.length < 1 || (propsState && propsState.record.key !== props.record.key)){
            getIntersectionTiming(props.record.key);
            getIntersectionTimingLog(props.record.key);
            setPropsState(props);
        }
    }, [props,propsState]);

    useEffect(() => {
        if(props.record){
            const params = {
                'intersection_ulid': props.record.key,
                'is_main': 1,
                'page_size': 65535,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.api}intersection/images${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',success:function(data){
                    if(data.res === 0){
                        if(data.dat.length > 0){
                            setImageData(data.dat);
                        }else{
                            setImageData([]);
                        }
                    }else{
                        message.error(data.msg, 1.5);
                    }
                }
            })
        }
    }, [props.record]);

    return (
        <>
            <Modal 
                width={820}
                style={{ top: 0}}
                // title={props.record.name}
                closable={false}
                open={open}
                keyboard={true}
                maskClosable={true}
                onCancel={handleCancel}
                footer={[
                    <Button key='back' onClick={handleCancel}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download}>下载</Button>,
                ]}
            >
                <div>
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Row style={{ margin: '10px' }}>
                            <Col span={2}><img src={XZTLOGO} height='45px' alt='新致腾' /></Col>
                            {
                                props.preGroup==='xzt'?<Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt='新致腾' /></Col>:''
                            }
                        </Row>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th colSpan='12'><h2>{props.record.name}</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>路口编码:</td><td colSpan='4' style={{ width: 240 }}>{props.record.number}</td>
                                    <td colSpan='2' style={{ width: 120,fontWeight: 'bold' }}>路口类型:</td><td colSpan='2' style={{ width: 120 }}>{props.record.structure}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>开机时间:</td><td colSpan='4' style={{ width: 240 }}>{props.record.boot_time}</td>
                                    <td colSpan='2' style={{ width: 120,fontWeight: 'bold' }}>放行方式:</td><td colSpan='2' style={{ width: 120 }}>{props.record.type}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>关机时间:</td><td colSpan='4' style={{ width: 240 }}>{props.record.shutdown_time}</td>
                                    <td colSpan='2' style={{ width: 120,fontWeight: 'bold' }}>所属区域:</td><td colSpan='2' style={{ width: 120 }}>{props.record.region}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>黄灯时间:</td><td colSpan='4' style={{ width: 240 }}>{props.record.yellow_light_duration}秒</td>
                                    <td colSpan='2' style={{ width: 120,fontWeight: 'bold' }}>建设年份:</td><td colSpan='2' style={{ width: 120 }}>{props.record.create_year}年</td>
                                </tr>
                                <tr>
                                    <td colSpan='12' style={{ width: 720,fontWeight: 'bold', textAlign: 'center' }}>配时方案</td>
                                </tr>
                                <tr>
                                    <td colSpan='2' rowSpan={getTimePeriodLength(timePeriodData,5)} style={{ width: 120,fontWeight: 'bold' }}>星期一至星期五</td><td colSpan='2' style={{ width: 120 }}>时段</td>
                                    {
                                        directions.length>0 && directions.map((item)=>{
                                            return <td key={item} colSpan='2' style={{ width: 120 }}>{item}</td>
                                        })
                                    }
                                </tr>
                                {
                                    timePeriodData.length>0 && timePeriodData.map((item)=>{
                                        return item.week.length===5?<tr key={item.timePeriod}>
                                            <td colSpan='2' style={{ width: 120 }}>{item.timePeriod}</td>
                                            {
                                                [0,1,2,3].map((i)=>{
                                                    return i >= item.durations.length?<td colSpan='2' style={{ width: 120 }} key={i}></td>
                                                    :<td colSpan='2' style={{ width: 120 }} key={i}>
                                                        {duration(item.durations[i].value)}
                                                        {
                                                            timeUlidIsInTimePeriodLogData(item.durations[i].timeUlid)?<Popover placement="top" content={returnTimePeriodLog(item.durations[i].timeUlid)}><Badge dot offset={[0, 5]}></Badge></Popover>:''
                                                        }
                                                    </td>
                                                })
                                            }
                                        </tr>:''
                                    })
                                }
                                <tr>
                                    <td colSpan='2' rowSpan={getTimePeriodLength(timePeriodData,2)} style={{ width: 120,fontWeight: 'bold' }}>星期六至星期日</td><td colSpan='2' style={{ width: 120 }}>时段</td>
                                    {
                                        directions.length>0 && directions.map((item)=>{
                                            return <td colSpan='2' style={{ width: 120 }} key={item}>{item}</td>
                                        })
                                    }
                                </tr>
                                {
                                    timePeriodData.length>0 && timePeriodData.map((item)=>{
                                        return item.week.length===2?<tr key={item.timePeriod}>
                                            <td colSpan='2' style={{ width: 120 }}>{item.timePeriod}</td>
                                            {
                                                [0,1,2,3].map((i)=>{
                                                    return i >= item.durations.length?<td colSpan='2' style={{ width: 120 }} key={i}></td>
                                                    :<td colSpan='2' style={{ width: 120 }} key={i}>
                                                        {duration(item.durations[i].value)}
                                                        {
                                                            timeUlidIsInTimePeriodLogData(item.durations[i].timeUlid)?<Popover placement="top" content={returnTimePeriodLog(item.durations[i].timeUlid)}><Badge dot offset={[0, 5]}></Badge></Popover>:''
                                                        }
                                                    </td>
                                                })
                                            }
                                        </tr>:''
                                    })
                                }
                                <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>信号机品牌:</td><td colSpan='4' style={{ width: 240 }}>{props.record.host_machine}</td>
                                    <td colSpan='2' style={{ width: 120,fontWeight: 'bold' }}>设备型号:</td><td colSpan='2' style={{ width: 120 }}>{props.record.host_machine_model}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>联网情况:</td><td colSpan='4' style={{ width: 240 }}>{props.record.host_machine_is_networking?'已联网':'未联网'}</td>
                                    <td colSpan='2' style={{ width: 120,fontWeight: 'bold' }}>运营商:</td><td colSpan='2' style={{ width: 120 }}>{props.record.operator}</td>
                                </tr>
                                {/* <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>机箱:</td><td colSpan='8' style={{ width: 480 }}>{props.record.chassis}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>支队:</td><td colSpan='4' style={{ width: 240 }}>{props.record.detachment}</td>
                                    <td colSpan='2' style={{ width: 120,fontWeight: 'bold' }}>区域:</td><td colSpan='2' style={{ width: 120 }}>{props.record.region}</td>
                                </tr> */}
                                <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>关联道路:</td><td colSpan='8' style={{ width: 480 }}>{
                                    props.record.road && props.record.road.replace(',','，').split('，').map((item,index) => {
                                        return <Popover 
                                            key={index} 
                                            placement='top'
                                            content={<div>
                                                {
                                                    roldInfo&&roldInfo.map((item,index) => {
                                                        return <div key={index}><Tag style={{ width:'23px' }} bordered={false} color='cyan'>{['T型路口','暂型路口'].includes(item.structure)?'т':'+'}</Tag>{item.name}</div>
                                                    })
                                                }
                                            </div>}
                                            onMouseEnter={()=>{getRoadInfo(item);}}
                                        ><Tag key={index} color='blue'>{item}</Tag></Popover>
                                    })
                                }</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>经度:</td><td colSpan='4' style={{ width: 240 }}>{props.record.longitude}</td>
                                    <td colSpan='2' style={{ width: 120,fontWeight: 'bold' }}>纬度:</td><td colSpan='2' style={{ width: 120 }}>{props.record.latitude}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 240,fontWeight: 'bold' }}>备注:</td><td colSpan='8' style={{ width: 480 }}>{props.record.description}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{ padding: '10px 30px' }}>图片附件：
                    {
                        imageData && imageData.length > 0 && imageData.map((item, index) => {
                            return <Button key={index} type='link' 
                            style={{ padding:0, border:0,height:22 }} 
                            onClick={()=>{showPreviewImage(item);}}><Tag color='blue'>{item.name}</Tag></Button>
                        })
                    }
                </div>
                </div>
            </Modal>
        </>
    );
};


class Lists extends Component{
    constructor(props){
        super(props);
        this.state = {
            dataLists: this.props.dataLists,
        }
    }

    update = (record) =>{this.props.setIsModalOpen(true, record);}
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        switch(action){
            case 'update':
                this.update(record);
                break;
            case 'disable':
                this.showInfoPromptModal(record,'DISABLE');
                break;
            case 'active':
                this.showInfoPromptModal(record,'ACTIVE');
                break;
            case 'delete':
                this.showInfoPromptModal(record,'DELETE');
                break;
            default:
                break;
        }
    }

    /**
     * 显示提示框信息信息
     * @param {*} record 
     */
    showInfoPromptModal = (record, action) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('info-prompt-modal-id'));
        }
        root.render(
            <InfoPromptModal
                open={true}
                isRefresh={this.props.isRefresh}
                action={action}
                record={record}
            />
        );
    }


    /**
     * 显示路口信息
     * @param {*} record 
     */
    showInfo = (record) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('show-info-id'));
        }
        root.render(
        <Info
            preGroup={this.props.preGroup}
            open={true}
            record={record}
        />);
    }

    /**
     * 显示产品信息
     * @param {*} record 
     */
    showProductInfo = (record) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('show-info-id'));
        }
        root.render(
            <ProductInfo
                open={true}
                number={record.product_number}
            />
        );
    }

    render(){
        const columns = [
            {title: '',width: 20,dataIndex: '',key: 'key',fixed: 'left',},
            {title: '路口编码',key: 'number',fixed: 'left', width: 120,
                render: (record) => <Button type='link' 
                    style={{ padding:0, border:0,height:22 }} 
                    onClick={()=>{this.showInfo(record);}}>{record.number}</Button>
            },
            {title: '路口简称',key: 'name',width: 210, ellipsis: true,
                render: (record) => <Button type='link' 
                    style={{ padding:0, border:0,height:22 }} 
                    onClick={()=>{this.showInfo(record);}}>{record.name}</Button>
            },
            {title: '路口全称',key: 'full_name', dataIndex: 'full_name', width: 320, },
            {title: '路口类型',key: 'structure', dataIndex: 'structure', width: 120, },
            {title: '放行方式',key: 'type', dataIndex: 'type', width: 120, },
            {title: '信号机品牌',dataIndex: 'host_machine',key: 'host_machine', width: 120,},
            {title: '设备型号',key: 'host_machine_model', width: 180,
                render: (record) => record.host_machine_model ? record.host_machine_model: '-'
            },
            {title: '建设年份',dataIndex: 'create_year',key: 'create_year', width: 100,},
            {title: '是否联网',key: 'host_machine_is_networking', width: 80,
                render: (record) => {
                    if(record.host_machine_is_networking){
                        return <Tag color='green'>是</Tag>
                    }else{
                        return <Tag color='red'>否</Tag>
                    }
                }
            },
            {title: '运营商',dataIndex: 'operator',key: 'operator', width: 100,},
            {title: '关联道路',key: 'road', width: 220,
                render: (record) => <>
                    {
                        record.road && record.road.replace(',','，').split('，').map((item, index) => {
                            return <Tag key={index} color='blue'>{item}</Tag>
                        })
                    }
                </>
            },
            // {title: '所属大队',dataIndex: 'detachment',key: 'detachment', width: 120,},
            {title: '所属区域',dataIndex: 'region',key: 'region', width: 120,},
            {title: '开机时间',key: 'boot_time', dataIndex: 'boot_time', width: 120, },
            {title: '关机时间',key: 'shutdown_time', dataIndex: 'shutdown_time', width: 120, },
            {title: '黄灯时间(s)',key: 'yellow_light_duration', dataIndex: 'yellow_light_duration', width: 100, },
            {title: '机箱',dataIndex: 'chassis',key: 'chassis', width: 120,},
            {title: 'UPS供电',key: 'yellow_light_duration', width: 80,
                render: (record) => {
                    if(record.is_ups_power_supply){
                        return <Tag color='green'>是</Tag>
                    }else{
                        return <Tag color='red'>否</Tag>
                    }
                }
            },
            {title: '主机地址',key: 'host_machine_ip', width: 200,
                render: function(record){
                    if(record.host_machine_ip){
                        return record.host_machine_ip
                    }else{
                        return '-'
                    }
                }
            },
            {title: '主机端口',key: 'host_machine_port', width: 100,
                render: function(record){
                    if(record.host_machine_port){
                        return record.host_machine_port
                    }else{
                        return '-'
                    }
                }
            },
            {title: '产品编码',key: 'host_machine_product_number', width: 150,
                render: (record) => <Button type='link' 
                    style={{ padding:0, border:0, height:15 }} 
                    onClick={()=>{this.showProductInfo(record);}}>{record.host_machine_product_number?record.host_machine_product_number:'-'}</Button>
            },
            {title: '标识编码',key: 'host_machine_icode', width: 100,
                render: function(record){
                    if(record.host_machine_icode){
                        return record.host_machine_icode
                    }else{
                        return '-'
                    }
                }
            },
            {title: '经度',key: 'longitude', width: 100,
                render: function(record){
                    if(record.longitude){
                        return record.longitude
                    }else{
                        return '-'
                    }
                }
            },
            {title: '纬度',key: 'latitude', width: 100,
                render: function(record){
                    if(record.latitude){
                        return record.latitude
                    }else{
                        return '-'
                    }
                }
            },
            {title: '创建时间', dataIndex: 'create_time', key: 'create_time',width: 120,},
            {title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: 80,},
            {title: '状态', key: 'status', fixed: 'right',width: 60,
                render: function(record){
                    for(let item of CNF.status){
                        if(parseInt(record.status) === parseInt(item.value)){
                            return item.key
                        }
                    }
                }
            },
            {title: '', key: 'operation', fixed: 'right', width: 80,
                render: (record) => {
                    let items = [];
                    if(this.props.btnLists.indexOf('btn_teii_intersection_update')>0){
                        items.push({key: '1', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('update', record)}}>修改</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_intersection_update') >= 0 
                    && record.status.toString() === CNF.status[0].value.toString()){
                        items.push({key: '2', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('disable', record)}}>禁用</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_intersection_update') >= 0 
                    && record.status.toString() === CNF.status[1].value.toString()){
                        items.push({key: '3', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('active', record)}}>激活</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_intersection_delete')>=0){
                        items.push({key: '4', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('delete', record)}}>删除</Button>)})
                    }
                    return (
                        <Dropdown menu={{ items, }}>
                            <Button type='link' style={{ padding:0, height: 10,margin:0 }}>
                                    操作
                                    <DownOutlined />
                            </Button>
                        </Dropdown>
                    );
                }
            }
        ];
        return(
            <div>
                <Table 
                    columns={columns} 
                    className='content-table-row'
                    size='middle'
                    dataSource={this.state.dataLists} 
                    scroll={{ x: winWidth}} 
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: winWidth>1440?CNF.pageSize:CNF.pageSize-2,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current,pageSize) => this.props.changePageSize(pageSize,current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class CPT extends Component{
    constructor(props){
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            number: '',
            name: '',
            detachment: '',
            region: '',
            road: '',
            structure: '',
            type: '',
            hostMachine: '',
            status: 1,
        }
    }

    isRefresh = () =>{this.setState({isRefresh: this.state.isRefresh===1 ? 0:1});}
    search = () => {this.setState({currentIndex: 1});this.isRefresh();}
    changeNumber = (e) =>{this.setState({number: e.target.value});this.search();}
    changeName = (e) =>{this.setState({name: e.target.value});this.search();}
    changeDetachment = (e) =>{this.setState({ detachment: e.target.value});this.search();}
    changeRegion = (e) =>{this.setState({ region: e.target.value});this.search();}
    changeRoad = (e) =>{this.setState({ road: e.target.value});this.search();}
    changeStructure = (e) =>{this.setState({ structure: e.target.value});this.search();}
    changeType = (e) =>{this.setState({ type: e.target.value});this.search();}
    changeHostMachine = (e) =>{this.setState({ hostMachine: e.target.value});this.search();}
    changeStatus = (value) =>{ this.setState({ status: value});this.search();}
    changeIndex = (index) =>{this.setState({currentIndex: index});this.isRefresh();}
    setIsModalOpen = (value, record) =>{this.setState({isModalOpen: value, record: record});}
    create = () =>{this.setIsModalOpen(true, null);}

    /**
     * 导入前检查
     * @param {*} info 
     * @returns 
     */
    uploadCheck = (info) =>{
        if (info.size > 10240000){
            message.error('上传文件超过10M，建议拆分文件！', 1);
            return false
        }
        if (info.name.match(/.xls[x]{0,1}/) === null){
            message.error('文件格式不对，只支持 xls 或 xlsx ！', 1);
            return false
        }
        return true
    }

    /**
     * 执行导入
     * @param {*} info 
     */
    upload = (info) =>{
        const _this = this;
        if (info.file.status === 'uploading') {
            message.loading({content: '文件正在导入...',key:'import', duration: 0});
        } else if (info.file.status === 'done') {
            message.success({content: '文件导入完成！',key:'import', duration: 1.5});
            if(info.file.response.dat){
                setTimeout(function(){
                    Modal.success({
                        title: '导入' + MODULENAME,
                        width: 500,
                        content: (
                            <div style={{ height:'300px', overflow:'scroll' }}>
                                <Row style={{ lineHeight: 2 }} key={0}>
                                    <Col span={3}>行号</Col>
                                    <Col span={9}>路口编码</Col>
                                    <Col span={12}>消息说明</Col>
                                </Row>
                                {
                                    info.file.response.dat.length &&
                                    info.file.response.dat.map((item) =>{
                                        return(
                                            <Row style={{ lineHeight: 2 }} key={item['key']}>
                                                <Col span={3}>{item['key']}</Col>
                                                <Col span={9}>{item['number']}</Col>
                                                <Col span={12}>{item['msg']}</Col>
                                            </Row>
                                        )
                                    })
                                }
                            </div>
                        ),
                        onOk() {_this.isRefresh();},
                    });
                },2000)
            }else{
                message.error(info.file.response.msg);
            }
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 导入失败！`);
        }
    }

    /**
     * 获取列表
     */
    getLists(){
        const _this = this;
        const params = {
            'name': this.state.name,
            'number': this.state.number,
            'detachment': this.state.detachment,
            'region': this.state.region,
            'road': this.state.road,
            'structure': this.state.structure,
            'type': this.state.type,
            'host_machine': this.state.hostMachine,
            'status': this.state.status,
            'page_size': winWidth>1440?CNF.pageSize:CNF.pageSize-2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}intersections${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    }else{
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        })
    }

    /***
    * 导出 Excel
    */
    export = (data) =>{
        var date = new Date(); 
        let option = {};  //    option代表的就是excel文件
        option.fileName = '路口信息明细-' + UdateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '路口信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '路口编码', 
                    '路口简称',
                    '路口全称',
                    '路口类型',
                    '放行方式',
                    '关联道路',
                    '信号机品牌',
                    '设备型号',
                    '建设年份',
                    '所属区域',
                    '是否联网',
                    '运营商',
                    '开机时间',
                    '关机时间',
                    '黄灯时间(s)',
                    '机箱',
                    'UPS供电',
                    '主机地址',
                    '主机端口',
                    '产品编码',
                    '标识编码',
                    '经度',
                    '纬度',
                    '备注'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出项目基础信息明细
     */
    exportObtain(e){
        if(e.target.nodeName !== 'svg'){ return; }
        const _this = this
        const params = {
            'name': this.state.name,
            'number': this.state.number,
            'detachment': this.state.detachment,
            'region': this.state.region,
            'road': this.state.road,
            'structure': this.state.structure,
            'type': this.state.type,
            'host_machine': this.state.hostMachine,
            'status': this.state.status,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}intersections${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        //  删除非必须字段
                        var d = [];
                        for(let i=0;i<data.dat.length;i++){
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['status'];
                            // delete item['product_number'];
                            delete item['create_username'];
                            delete item['create_displayname'];
                            delete item['create_time'];
                            delete item['update_time'];
                            if(item['host_machine_is_networking']){
                                item['host_machine_is_networking'] = '是';
                            }else{
                                item['host_machine_is_networking'] = '否';
                            }
                            if(item['is_ups_power_supply']){
                                item['is_ups_power_supply'] = '是';
                            }else{
                                item['is_ups_power_supply'] = '否';
                            }
                            d.push(item);
                        }
                        _this.export(d);
                    }else{
                        _this.export([]);
                    }
                }else{
                    message.error(data.msg);
                }
            }
        })
    }

    componentDidUpdate(){
        if(this.state.init !== this.state.isRefresh){
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount(){
        this.getLists();
    }

    render(){
        return(
            <>
                <div>
                    <Row style={{ height: 60, paddingTop:10, paddingLeft:20}}>
                        <Col span={2}>
                            <Input
                                onChange={this.changeName}
                                onPressEnter={this.search}
                                placeholder='路口简称...'
                                value={this.state.name}
                            />
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeNumber}
                                onPressEnter={this.search}
                                placeholder='路口编码...'
                                value={this.state.number}
                            />
                        </Col>
                        {/* <Col span={2} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeDetachment}
                                onPressEnter={this.search}
                                placeholder='所属大队...'
                                value={this.state.detachment}
                            />
                        </Col> */}
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeRegion}
                                onPressEnter={this.search}
                                placeholder='所属区域...'
                                value={this.state.region}
                            />
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeRoad}
                                onPressEnter={this.search}
                                placeholder='关联道路...'
                                value={this.state.road}
                            />
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeStructure}
                                onPressEnter={this.search}
                                placeholder='路口类型...'
                                value={this.state.structure}
                            />
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeType}
                                onPressEnter={this.search}
                                placeholder='放行方式...'
                                value={this.state.type}
                            />
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeHostMachine}
                                onPressEnter={this.search}
                                placeholder='主机...'
                                value={this.state.hostMachine}
                            />
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Select 
                                value={this.state.status}
                                style={{ width: '100%' }} 
                                onChange={this.changeStatus}
                            >
                                <Option value=''>状态</Option>
                                {
                                    CNF.status && CNF.status.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={2} style={{ lineHeight: 2.2,marginLeft: 10 }}>
                        {
                            this.props.btnLists.indexOf('btn_teii_intersection_create') >=0 ? (
                                <>
                                    <Button 
                                        title={MODULENAME}
                                        type='link'
                                        icon={<PlusOutlined/>}
                                        onClick={() =>{
                                            this.create();
                                        }}>
                                    </Button>
                                    <Upload
                                        action={CNF.api + 'intersections'}
                                        headers={AddRequestHeaders()}
                                        onChange={this.upload}
                                        beforeUpload={this.uploadCheck}
                                        showUploadList={false}
                                        name='file'
                                        accept='xlsx,xls'
                                    >
                                        <Button
                                            title={MODULENAME}
                                            type='link'
                                            icon={<ImportOutlined/>}
                                        >
                                        </Button>
                                    </Upload>
                                </>):''
                            }
                            {
                                this.props.btnLists.indexOf('btn_teii_intersection_export') >=0 ? (
                                    <Button
                                        title={MODULENAME}
                                        type='link'
                                        icon={<ExportOutlined/>}
                                        onClick={(e) =>{
                                            this.exportObtain(e);
                                        }}>
                                    </Button>
                                ):''
                            }
                        </Col>
                        <Entity 
                            policy={this.props.policy}
                            isModalOpen={this.state.isModalOpen} 
                            record={this.state.record}
                            setIsModalOpen={this.setIsModalOpen} 
                            isRefresh={this.isRefresh}
                        />
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Lists
                                preGroup={this.props.preGroup}
                                btnLists={this.props.btnLists}
                                dataLists={this.state.dataLists} 
                                currentIndex={this.state.currentIndex}
                                pageCount={this.state.pageCount} 
                                changeIndex={this.changeIndex} 
                                setIsModalOpen={this.setIsModalOpen}
                                isRefresh={this.isRefresh}
                            />
                        </Col>
                    </Row>
                </div>
                <div id='show-info-id'></div>
                <div id='show-image-id'></div>
                <div id='info-prompt-modal-id'></div>
            </>
        );
    }
}

export default CPT